import { Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { DocumentDate } from '@features/invoices/elements/DocumentDate'
import { DocumentDetailsCard } from '@features/invoices/elements/DocumentDetailsCard'

interface DemoInvoiceSentDetailsCardProps {
  companyName: string
  issueDate: Date
}

export const DemoInvoiceSentDetailsCard = ({
  companyName,
  issueDate,
}: DemoInvoiceSentDetailsCardProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <DocumentDetailsCard isLoading={false}>
      <DocumentDetailsCard.Entry title={t('external_invoices.view.sidebar.details_card.customer')}>
        <Text alignment="left" variant="bodySM" weight="bold">
          {companyName}
        </Text>
      </DocumentDetailsCard.Entry>
      <DocumentDetailsCard.Entry title={t('external_invoices.view.sidebar.details_card.issue_date')}>
        <DocumentDate date={issueDate.toISOString()} />
      </DocumentDetailsCard.Entry>
    </DocumentDetailsCard>
  )
}
